module.exports = __webpack_public_path__ + "img/wz-5-7.2f4feaab.png";